<div class="p-4 mt-8">
  <h1
    class="text-2xl lg:text-4xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white mb-8 md:mb-12"
  >
    {{ 'PRIVACY-POLICY.TITLE' | translate }}
  </h1>
  <ol
    class="w-full space-y-1 text-gray-500 list-decimal list-inside dark:text-gray-400"
  >
    <li
      class="pl-2 text-lg font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white"
    >
      Datenschutz auf einen Blick
    </li>
    <p class="p-5 text-gray-900 dark:text-white">
      Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit
      Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen
      oder unsere Leistungen in Anspruch nehmen. Personenbezogene Daten sind
      alle Daten, mit denen Sie persönlich identifiziert werden können.
      Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer
      unter diesem Text aufgeführten Datenschutzerklärung. Die Bedingungen
      dieser Erklärung können sich mitunter ändern. Bitte nutzen Sie diese
      Seite, um sich zu informieren, da wir eventuelle Änderungen hier
      einstellen.
    </p>
    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Datenerfassung auf unserer Website
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Die Datenverarbeitung auf dieser Website erfolgt durch den
      Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser
      Website entnehmen. Ihre Daten werden zum einen dadurch erhoben, dass Sie
      uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie
      in ein Bewerbungsformular eingeben. Andere Daten werden automatisch beim
      Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem
      technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des
      Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie
      unsere Website betreten. Ein Teil der Daten wird erhoben, um eine
      fehlerfreie Bereitstellung der Website zu gewährleisten oder Ihr
      Nutzerverhalten zu analysieren. Andere Daten werden zur Bearbeitung Ihrer
      Bewerbung verarbeitet. Der Websitebetreiber haftet nicht für eingebundene
      Links zu anderen Websites, soweit diese Seiten nicht von ihm betrieben
      werden. Sofern personenbezogene Daten nicht über diese Website erhoben
      werden, ist der jeweils für die Erhebung Verantwortliche für die
      Erbringung der Informationspflichten nach den Art. 13, 14 DSGVO
      verantwortlich. Wir raten Ihnen, die Datenschutzerklärungen einer jeden
      Webseite, aufmerksam zu lesen. Sie haben jederzeit das Recht unentgeltlich
      Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten
      personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die
      Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu
      sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit
      unter der im Impressum angegebenen Adresse an uns wenden. Des Weiteren
      steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
      Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung
      der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Details
      hierzu entnehmen Sie der Datenschutzerklärung unter „Recht auf
      Einschränkung der Verarbeitung“.
    </p>
    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Analyse-Tools und Tools von Drittanbietern
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch
      ausgewertet werden. Das geschieht vor allem mit Cookies und mit
      sogenannten Analyseprogrammen. Die Analyse Ihres Surf-Verhaltens erfolgt
      in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zurückverfolgt
      werden. Sie können dieser Analyse widersprechen oder sie durch die
      Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen zu
      diesen Tools und über Ihre Widerspruchsmöglichkeiten finden Sie in der
      folgenden Datenschutzerklärung.
    </p>

    <li
      class="pl-2 text-lg font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white"
    >
      Allgemeine Hinweise und Pflichtinformationen
    </li>
    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">Datenschutz</p>
    <p class="p-5 text-gray-900 dark:text-white">
      Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
      sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
      entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser
      Datenschutzerklärung. Wenn Sie diese Website benutzen oder unsere
      Leistungen in Anspruch nehmen, werden verschiedene personenbezogene Daten
      erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich
      identifiziert werden können. Die vorliegende Datenschutzerklärung
      erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie
      erläutert auch, wie und zu welchem Zweck das geschieht. Wir weisen darauf
      hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation
      per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der
      Daten vor dem Zugriff durch Dritte ist nicht möglich.
    </p>
    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Widerruf Ihrer Einwilligung zur Datenverarbeitung
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
      Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
      jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an
      uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung
      bleibt vom Widerruf unberührt.
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen
      Direktwerbung (Art. 21 DSGVO)
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f
      DSGVO erfolgt, haben Sie jederzeit das Recht, aus Gründen, die sich aus
      Ihrer besonderen Situation ergeben, gegen die Verarbeitung Ihrer
      personenbezogenen Daten Widerspruch einzulegen; dies gilt auch für ein auf
      diese Bestimmungen gestütztes Profiling. Die jeweilige Rechtsgrundlage,
      auf denen eine Verarbeitung beruht, entnehmen Sie dieser
      Datenschutzerklärung. Wenn Sie Widerspruch einlegen, werden wir Ihre
      betroffenen personenbezogenen Daten nicht mehr verarbeiten, es sei denn,
      wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen,
      die Ihre Interessen, Rechte und Freiheiten überwiegen oder die
      Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von
      Rechtsansprüchen (Widerspruch nach Art. 21 Abs. 1 DSGVO). Werden Ihre
      personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, so
      haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung Sie
      betreffender personenbezogener Daten zum Zwecke derartiger Werbung
      einzulegen; dies gilt auch für das Profiling, soweit es mit solcher
      Direktwerbung in Verbindung steht. Wenn Sie widersprechen, werden Ihre
      personenbezogenen Daten anschließend nicht mehr zum Zwecke der
      Direktwerbung verwendet (Widerspruch nach Art. 21 Abs. 2 DSGVO).
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Beschwerderecht bei der zuständigen Aufsichtsbehörde
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
      Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
      Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder
      des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht
      unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher
      Rechtsbehelfe.
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Recht auf Datenübertragbarkeit
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder
      in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an
      einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu
      lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen
      Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar
      ist.
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      SSL- bzw. TLS-Verschlüsselung
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
      vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die
      Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung.
      Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile
      des Browsers von „http://“ auf „https://“ wechselt und an dem
      Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL- bzw.
      TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
      übermitteln, nicht von Dritten mitgelesen werden.
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Auskunft, Sperrung, Löschung und Berichtigung
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das
      Recht auf unentgeltliche Auskunft über Ihre gespeicherten
      personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
      Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder
      Löschung dieser Daten, soweit dem keine gesetzliche Aufbewahrungspflicht
      oder unser berechtigtes Interesse, z.B. eine Beweispflicht in einem
      Verfahren nach dem Allgemeinen Gleichbehandlungsgesetz, entgegensteht.
      Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können
      Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns
      wenden.
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Widerspruch gegen Werbe-E-Mails
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
      Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung
      und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der
      Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der
      unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails,
      vor.
    </p>

    <li
      class="pl-2 text-lg font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white"
    >
      Bewerbungen
    </li>
    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Umfang der Datenverarbeitung
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Wir schreiben Vakanzen im Auftrag unserer Kunden aus, welche die
      entsprechende Position besetzen möchten, und führen für diese Teile des
      Bewerbungsverfahrens durch. Nutzer können sich auf eine vakante Stelle
      oder initiativ mittels des auf unserer Website bereitgestellten
      Bewerbungs- und Kontaktformulars, per E-Mail, über den Postweg oder durch
      Nutzung von sozialen Medien oder Jobportalen, in denen die vakanten
      Stellen von uns verbreitet wurden, bewerben. In einigen Fällen rekrutieren
      wir für unsere Kunden auch aktiv Personal. Hierfür kontaktieren wir Sie
      direkt, beispielsweise über Business-Netzwerke wie XING oder LinkedIn, um
      zu prüfen, ob eine vakante Stelle oder die Aufnahme in unsere Datenbank
      für Sie interessant sein könnte. Hierfür verarbeiten wir nur Ihren Namen
      und Ihre Kontaktdaten sowie auf den vorgenannten Plattformen oder anderen
      Websites veröffentlichte Informationen, insbesondere über Ihren
      derzeitigen Arbeitsort, Ihre berufliche Qualifikation und Ihren Werdegang.
      Im Fall einer Bewerbung werden die von Ihnen übermittelten Daten von uns
      zum Zwecke der Abwicklung des Bewerbungsverfahrens verarbeitet und in
      unserem Bewerbermanagementsystem gespeichert. Die Datenverarbeitung
      erfolgt unter Beachtung der gesetzlichen Vorschriften, insbesondere der
      EU-DSGVO sowie des Allgemeinen Gleichbehandlungsgesetzes und,
      vorbehaltlich einer anderweitig erteilten Einwilligung, nur für die
      Erfüllung der Zwecke nach dieser Datenschutzbestimmung. Zu den von uns zu
      erbringenden Leistungen im Bewerbungsverfahren gehört beispielsweise die
      Sichtung der Bewerbungsunterlagen, das Führen von Vorgesprächen mit
      Bewerbern, das Einholen fehlender Unterlagen sowie die Auswahl der
      Kandidat(innen), die wir Arbeitgebern für eine vakante Stelle als geeignet
      vorschlagen. Zugriff auf die eingehenden Bewerbungen haben die Mitarbeiter
      des für die Verarbeitung Verantwortlichen, die mit der Bearbeitung einer
      Vakanz oder von Initiativbewerbungen befasst sind oder sonst für die
      Zwecke der weiteren Bearbeitung der Bewerbung Kenntnis haben müssen.
      Sollte Ihre Bewerbung nach unserer Einschätzung oder der des Arbeitgebers
      nicht auf die Stelle passen, für die Sie sich beworben haben, werden wir
      Sie gegebenenfalls für eine andere vakante Stelle vorschlagen. Sollte auch
      dies nicht in Frage kommen, Ihr Profil aber gut in unser Portfolio passen,
      speichern wir Ihre Bewerbung in unserer Datenbank, um Sie über zukünftig
      zu besetzende Stellen, welche nach Ihrem Profil für Sie von Interesse sein
      könnten, benachrichtigen zu können. In diesem Fall informieren wir Sie in
      Textform, üblicherweise per E-Mail über die Aufnahme in unseren
      Bewerberpool. Haben Sie sich initiativ bei uns beworben, werden Sie
      ebenfalls zunächst in unseren Bewerberpool aufgenommen, ohne dass dies
      einer Mitteilung durch uns bedarf. Anschließend wird regelmäßig geprüft,
      ob Ihre Bewerbung für eine Vakanz eines Kunden berücksichtigt werden kann.
      Neben der Verarbeitung im Rahmen des Bewerbungsprozesses oder zur Aufnahme
      in unseren Bewerberpool, verwenden wir Ihre Bewerberdaten für statistische
      Auswertungen und Analysen zur Optimierung unserer Leistungen.
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Weitergabe an unsere Kunden
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Die von uns selektierten Bewerber werden einschließlich aller uns
      übermittelten und von uns aufbereiteten personenbezogenen Daten an
      Unternehmen, in dessen Betrieb Sie im Falle einer erfolgreichen
      Vermittlung eingestellt werden sollen, weitergeleitet. Wir informieren Sie
      zum Zeitpunkt der Weiterleitung, wenn Ihre Bewerbung an ein Unternehmen
      übermittelt wird. Anonymisierte Bewerberdaten können bereits vorab ohne
      gesonderte Information an einen Arbeitgeber übermittelt werden.
      Bewerberdaten werden in der Regel per E-Mail oder durch Freigabe in
      unserem Kundenportal an Arbeitgeber übermittelt. Der Zugriff auf das
      Kundenportal ist durch technische und organisatorische Maßnahmen
      geschützt. Arbeitgeber dürfen ausschließlich berechtigtem Personal (z.B.
      Recruiter, HR Manager) Zugang zu Bewerbungen gewähren. Der Arbeitgeber
      verarbeitet die Daten für die weitere Durchführung des
      Bewerbungsverfahrens und gegebenenfalls zur Begründung und Abwicklung
      eines Beschäftigungsverhältnisses sowie zur Durchführung des mit uns
      geschlossenen Vertrages unter Beachtung der derzeit gültigen gesetzlichen
      Vorschriften. Der Kunde darf personenbezogene Daten von Bewerbern nur zum
      Zwecke der Bewerbung nutzen. Jede weitere Nutzung der Daten, bedarf der
      vorherigen, aktiven Einwilligung durch den Bewerber.
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Weitergabe an Dritte
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Zum Zwecke der effizienten Verarbeitung Ihrer Daten, der fehlerfreien
      Bereitstellung der Website sowie der Verwaltung unseres Betriebs, geben
      wir Ihre Daten auch an andere Dritte als den Kunden weiter. Wir geben Ihre
      Daten an Dienstleister weiter, die in unserem Auftrag Leistungen
      erbringen, wie IT-Dienstleister, Speicheranbieter, Berater, Anwälte,
      Wirtschaftsprüfer oder Buchhalter. Diese Dienstleister haben nur den
      Zugriff auf Ihre personenbezogenen Daten, den sie haben müssen, um ihrer
      Tätigkeit nachkommen zu können. Es ist ihnen nicht erlaubt, diese
      personenbezogenen Informationen zu anderen Zwecken zu verwenden. Zudem
      sind unsere Dienstleister dazu angehalten, bei der Verarbeitung Ihrer
      Daten größtmögliche Sorgfalt walten zu lassen und jedwede Maßnahme zu
      ergreifen, welche den vertraulichen, sicheren Umgang mit den Daten
      gewährleistet und deren Bekanntgabe an Dritte verhindert. Wir geben Ihre
      Daten an staatliche Stellen oder Behörden weiter, wenn wir nach
      rechtlicher Prüfung oder im guten Glauben gesetzlich oder wegen einer
      anderen Vorschrift dazu angehalten sind.
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Rechtsgrundlage der Datenverarbeitung
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Die Rechtsgrundlage für die Verarbeitung Ihrer Daten im Rahmen des
      Bewerbungsprozesses sowie für die mögliche Weitergabe an Arbeitgeber ist
      Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), die Sie mit Ihrer
      Bewerbung bei uns abgeben. Sie können diese Einwilligung jederzeit
      widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die
      Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge
      bleibt vom Widerruf unberührt. Die Rechtsgrundlage für die Verarbeitung
      Ihrer Daten im Rahmen des aktiven Recruitings sowie für die Aufnahme in
      unseren Bewerberpool und die Weitergabe anonymisierter Bewerberdaten an
      Arbeitgeber ist unser berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO).
      Das berechtigte Interesse liegt darin, dass diese Verwendung zu einer
      schnelleren und passgenauen Besetzung von Stellen führt. Die
      Rechtsgrundlage für die Weitergabe Ihrer Daten an andere Dritte als den
      Kunden ist unser berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO). Das
      berechtigte Interesse liegt in der effizienten Verarbeitung Ihrer Daten,
      der fehlerfreien Bereitstellung der Website sowie der Verwaltung unseres
      Betriebs, z.B. Abrechnung unserer Leistungen gegenüber dem Kunden. Die
      Rechtsgrundlage für die Verarbeitung Ihrer Daten im Rahmen von
      statistischen Auswertungen und Analysen ist unser berechtigtes Interesse
      (Art. 6 Abs. 1 lit. f DSGVO). Das berechtigte Interesse liegt darin, dass
      diese Verwendung zu einer Optimierung unserer Recruiting-Lösung führt, was
      die Kundenzufriedenheit erhöht. Soweit wir in Zusammenhang mit Ihrer
      Bewerbung gesetzlich verpflichtet sind, Ihre Daten zu verarbeiten oder an
      Dritte weiterzugeben (wie beispielsweise nach Vorschriften des Arbeits-,
      Steuer- und Sozial
    </p>

    <p class="px-5 pt-5 font-bold text-gray-900 dark:text-white">
      Dauer der Speicherung
    </p>
    <p class="p-5 text-gray-900 dark:text-white">
      Daten, die wir auf Grundlage Ihrer Einwilligung oder unseres berechtigten
      Interesses verarbeiten, löschen oder anonymisieren wir, wenn Sie uns zur
      Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der
      Zweck für die Datenspeicherung entfällt, z.B. nach abgeschlossener
      Bearbeitung einer vakanten Stelle. Zwingende gesetzliche Bestimmungen oder
      sonstige berechtigte Interessen von uns oder unserem Kunden, z.B. eine
      Beweispflicht in einem Verfahren nach dem Allgemeinen
      Gleichbehandlungsgesetz, bleiben unberührt. In diesem Fall erfolgt die
      Löschung oder Anonymisierung mit Wegfall des Grundes. Sind die Daten
      aufgrund gesetzlicher Verpflichtungen aufzubewahren, werden die Daten nach
      Ablauf der jeweiligen Aufbewahrungspflicht gelöscht oder anonymisiert. Für
      den Widerruf Ihrer Einwilligung oder die Aufforderung zur Löschung Ihrer
      Daten reicht eine kurze, formlose E-Mail an uns. Für alle
      personenbezogenen Daten, die im Zusammenhang mit einer Bewerbung an einen
      Arbeitgeber weitergeleitet werden, kann dieser die Löschung oder Korrektur
      dieser Daten nur selbst vornehmen. Bewerber können sich direkt an den
      Arbeitgeber oder per E-Mail oder Post an uns wenden. Wir werden Ihre
      Anfrage dann umgehend an den zuständigen Kontakt bei unserem Kunden
      weiterleiten. Die Löschung von Bewerberdaten beim Arbeitgeber bedeutet
      nicht gleichzeitig die Löschung der Daten bei uns. Sollten Sie auch die
      Löschung ihrer Bewerberdaten bei uns wünschen, müssen Sie dies
      ausdrücklich angeben. Zum Schutze personenbezogener Daten, behalten wir
      uns gemäß Art.11 EU-DSGVO vor, bei begründetem Zweifel an der Identität
      der natürlichen Person, die den Antrag gemäß den Art. 15 bis 21 der
      EU-DSGVO stellt, zusätzliche Informationen anzufordern, die zur
      Bestätigung der Identität der betroffenen Person erforderlich sind.
    </p>
  </ol>
</div>
